import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {translate} from '@modifi/plugin-i18n'
import {aReplace} from '@modifi/router'
import {withProgress} from '@modifi/ui'
import {aShowDialog} from '@modifi/plugin-dialogs'

import Tasks, {TasksProps} from './Tasks'
import {aFetchTasksWithUrlParams, selectUpdateErrorMessage} from './store'
import {keyWindowFromUrlForTasks} from '../../utils/keyWindowFromUrl'
import {
  selectTasksAreLoadingByParams,
  selectTasksByParams,
  selectTasksTotalCountForParams,
  selectTasksTotalPagesForParams,
} from '../../data/tasks'
import {INTERNAL_NOTE_DIALOG} from './dialogs'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  TasksProps,
  'taskList' | 'loading' | 'totalCount' | 'totalPages' | 'updateErrorMessage'
> => {
  const currentKeyWindow = keyWindowFromUrlForTasks(state)

  return {
    // @ts-expect-error type of taskList will probably get fixed when
    // right api-clients will be generated @todo_tasks
    taskList: selectTasksByParams(state, currentKeyWindow),
    loading: selectTasksAreLoadingByParams(state, currentKeyWindow),
    totalCount: selectTasksTotalCountForParams(state, currentKeyWindow),
    totalPages: selectTasksTotalPagesForParams(state, currentKeyWindow),
    updateErrorMessage: selectUpdateErrorMessage(state),
  }
}

const mapDispatchToProps = {
  fetchTasks: aFetchTasksWithUrlParams,
  replaceUrl: aReplace,
  showInternalNote: (
    internalNote: string | undefined,
    internalNoteModifiedBy: string | undefined,
    taskId: string,
    canEdit: boolean
  ): ReturnType<typeof aShowDialog> =>
    aShowDialog(INTERNAL_NOTE_DIALOG, {internalNote, internalNoteModifiedBy, taskId, canEdit}),
}

export default compose(
  translate('kartavya'),
  connect(mapStateToProps, mapDispatchToProps)
)(withProgress({defaultExpectedDuration: 1500})(Tasks))
